import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Input/InputTextarea.css'

{/*
<InputTextarea
    theme={'light | dark'}
    ref={}
    icon={<FontAwesomeIcon icon={faPen} />}
    text={} setText={}
    textError={} setTextError={}
    nullable={false}
    placeholder={""}
    nbRow={6}
    onPressEnter={() => {}}
/>
--inputTextLight: #ffffff;
--inputTextLightText: #49574b;
--inputTextDark: #eef5ef;
--inputTextDarkText: #49574b;
--inputTextSuccess: #435e48;
--inputTextError: #BB4040;
*/}

const InputTextarea = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        inputTextareaRef: inputTextareaRef,
        textValidation: (text) => textValidation(text)
    }))

    const inputTextareaRef = useRef(null)

    function textValidation(text) {

        if (props.nullable && text.length === 0) {
            props.setTextError(null)
            return true
        }
        if (text && text.length > 0) {
            props.setTextError(false)
            return true
        } else {
            props.setTextError(true)
            return false
        }

    }

    function textFormat(text) {

        if (text) {
            const textFormat = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
            props.setText(textFormat)
        }

    }

    return (

        <InputGroup>
            <InputGroup.Text className={['inputTextareaIcon', props.theme === 'light' ? 'inputTextareaIconLight' : 'inputTextareaIconDark', props.textError === false ? 'inputTextareaIconSuccess' : props.textError ? 'inputTextareaIconError' : null].join(" ")}>
                {props.icon ? props.icon : <FontAwesomeIcon icon={faPen} />}
            </InputGroup.Text>
            <Form.Control
                ref={inputTextareaRef}
                as={'textarea'}
                placeholder={props.placeholder}
                value={props.text}
                rows={props.nbRow ? props.nbRow : 10}
                className={['inputTextarea', props.theme === 'light' ? 'inputTextareaLight' : 'inputTextareaDark', props.textError === false ? 'inputTextareaSuccess' : props.textError ? 'inputTextareaError' : null].join(" ")}
                onChange={(e) => { props.setText(e.target.value); textValidation(e.target.value); textFormat(e.target.value) }}
                onKeyPress={(event) => props.onPressEnter && event.key === "Enter" ? props.onPressEnter() : null}
            />
        </InputGroup>

    )

})

export default InputTextarea
